<section class="bg-gray-50 dark:bg-gray-900 min-h-screen py-3 sm:py-5">
  <div class="px-4 mx-auto max-w-screen-2xl lg:px-12">

    <!-- Header Section -->
    <div class="mb-6">
      <div *ngIf="view == 1" class="flex items-center mb-4">
        <button [routerLink]="['/console/invoice-dashboard']" class="mr-3 p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
          <i class="fas fa-arrow-left"></i>
        </button>
        <h1 class="text-2xl font-bold text-blue-600">
          {{shops && (shops[shop] || "Todas las tiendas")}}
        </h1>
      </div>

      <div *ngIf="view != 1" class="flex items-center justify-between">
        <button (click)="closeInstallment()" class="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Main Content -->
    <div class="space-y-6">

      <!-- View 1: Financial Payments List -->
      <div *ngIf="view == 1">

        <!-- Loading Statistics -->
        <div *ngIf="loading_stadistic" class="flex items-center justify-center py-12">
          <div class="text-center">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
            <p class="text-gray-600 mt-4">Cargando estadísticas...</p>
          </div>
        </div>

        <!-- Filters Section -->
        <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

            <!-- Filter Type -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">Filtrar por</label>
              <select (change)="resetType()" [(ngModel)]="type" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                <option value="f">Fecha</option>
                <option value="n"># Crédito</option>
              </select>
            </div>

            <!-- Date Range Filter -->
            <div *ngIf="type == 'f'">
              <label class="block text-sm font-medium text-gray-700 mb-2">Rango de fechas</label>
              <div class="relative">
                <input
                  id="demo-external"
                  (onSet)="birthdaySet()"
                  [(ngModel)]="range"
                  mbsc-range
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  [mbsc-options]="dateSetting3"
                  #externalRange="mobiscroll"
                />
              </div>
            </div>

            <!-- Credit Search -->
            <div *ngIf="type == 'n'" class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-700 mb-2">Buscar por número de crédito</label>
              <div class="flex space-x-2">
                <div class="flex-1 relative">
                  <input
                    type="text"
                    [(ngModel)]="search_form"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="credito-#"
                  />
                </div>
                <button
                  (click)="search_form_method()"
                  [disabled]="loading"
                  class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
                >
                  <span>Buscar</span>
                  <i *ngIf="loading" class="fas fa-spinner fa-spin ml-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Statistics Cards -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">

          <!-- Loading Statistics -->
          <div *ngIf="loading_stadistic" class="md:col-span-2 lg:col-span-4 flex items-center justify-center py-8">
            <div class="text-center">
              <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
              <p class="text-gray-600 mt-2 text-sm">Cargando estadísticas...</p>
            </div>
          </div>

          <!-- Statistics Cards Content -->
          <ng-container *ngIf="!loading_stadistic">
            <!-- Pending -->
            <div (click)="filterData.status = 'p'; filter()" class="bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow border-l-4 border-yellow-400">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-yellow-600">Pendientes</p>
                  <p class="text-2xl font-bold text-gray-900">{{stadistic?.pending}}</p>
                </div>
                <div class="p-3 bg-yellow-100 rounded-full">
                  <i class="fas fa-clock text-yellow-600"></i>
                </div>
              </div>
            </div>

            <!-- Completed -->
            <div (click)="filterData.status = 'c'; filter()" class="bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow border-l-4 border-green-400">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-green-600">Completados</p>
                  <p class="text-2xl font-bold text-gray-900">{{stadistic?.complete}}</p>
                </div>
                <div class="p-3 bg-green-100 rounded-full">
                  <i class="fas fa-check-circle text-green-600"></i>
                </div>
              </div>
            </div>

            <!-- Draft -->
            <div (click)="filterData.status = 't'; filter()" class="bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow border-l-4 border-gray-400">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-gray-600">En borrador</p>
                  <p class="text-2xl font-bold text-gray-900">{{stadistic?.trash}}</p>
                </div>
                <div class="p-3 bg-gray-100 rounded-full">
                  <i class="fas fa-file-alt text-gray-600"></i>
                </div>
              </div>
            </div>

            <!-- Total -->
            <div (click)="filterData.status = 'all'; filter()" class="bg-white rounded-lg shadow-sm p-6 cursor-pointer hover:shadow-md transition-shadow border-l-4 border-blue-400">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm font-medium text-blue-600">Total</p>
                  <p class="text-2xl font-bold text-gray-900">{{stadistic?.pending + stadistic?.complete}}</p>
                </div>
                <div class="p-3 bg-blue-100 rounded-full">
                  <i class="fas fa-chart-bar text-blue-600"></i>
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Active Filter Display -->
        <div *ngIf="!loading && filterData?.status != ''" class="flex items-center space-x-2 mb-4">
          <button (click)="resetFilter();filter()" class="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full">
            <i class="fas fa-times"></i>
          </button>
          <span class="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full">
            <span *ngIf="filterData?.status == 'c'">Completados</span>
            <span *ngIf="filterData?.status == 'p'">Pendientes</span>
            <span *ngIf="filterData?.status == 't'">En borrador</span>
            <span *ngIf="filterData?.status == 'all'">Total</span>
          </span>
        </div>

        <!-- Results Count -->
        <div *ngIf="!loading && rows?.length > 0" class="text-right text-sm text-gray-600 mb-4">
          {{rows?.length}} resultados
        </div>

        <!-- Financial Payments List -->
        <div class="space-y-4">
          <div *ngFor="let item of rows" class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">

            <!-- Customer Header -->
            <div class="p-4 border-b border-gray-200">
              <div class="flex items-center space-x-3 cursor-pointer" [routerLink]="['/console/person/financial-payments/',item?.customer?.code]">
                <div class="flex-shrink-0">
                  <img
                    *ngIf="item?.customer?.file_selfie"
                    class="w-10 h-10 rounded-full object-cover"
                    [src]="sanitize(item?.customer?.file_selfie?.url)"
                    alt="Avatar"
                  />
                  <img
                    *ngIf="!item?.customer?.file_selfie && item?.customer.gender != 'F'"
                    class="w-10 h-10 rounded-full object-cover"
                    [src]="sanitize('../assets/public/images/avatar.png')"
                    alt="Avatar"
                  />
                  <img
                    *ngIf="!item?.customer?.file_selfie && item?.customer.gender == 'F'"
                    class="w-10 h-10 rounded-full object-cover"
                    [src]="sanitize('../assets/public/images/avatara-female.png')"
                    alt="Avatar"
                  />
                </div>
                <div>
                  <h3 class="text-lg font-semibold text-gray-900 capitalize">
                    {{item?.customer?.name}} {{item?.customer?.lastName}}
                  </h3>
                </div>
              </div>
            </div>

            <!-- Payment Details -->
            <div class="p-6">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <!-- Total Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Compra financiada total</p>
                  <p class="text-xl font-bold text-gray-900">
                    {{item?.totalAmount | currency:'USD':'': '1.2-2'}}
                    <span class="text-sm font-normal text-gray-500">USD</span>
                  </p>
                </div>

                <!-- Approval Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha de aprobación</p>
                  <p class="text-sm text-gray-900">{{item?.dueDate | date: 'dd/MM/yyyy h:mm:ss a'}}</p>
                </div>

                <!-- Transaction ID -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">ID transacción</p>
                  <p class="text-sm text-gray-900 font-mono">{{item?.identifier}}</p>
                  <!-- 🆕 Badge de crédito clasificado como pérdida incobrable -->
                  <span *ngIf="item?.cartera?.estado === 'INCOBRABLE'"
                        class="inline-flex items-center mt-1 px-2 py-0.5 rounded-md text-xs font-semibold bg-red-50 text-red-700 border border-red-200">
                    Pérdida Incobrable
                  </span>
                </div>

                <!-- Document ID -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">ID documento</p>
                  <p class="text-sm text-gray-900 font-mono">{{item?.merchantNumber}}</p>
                </div>

                <!-- Store -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Tienda</p>
                  <p class="text-sm text-gray-900">{{shops[item?.provider_transaction?.shop]}}</p>
                </div>

                <!-- Cash Register -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Caja</p>
                  <p class="text-sm text-gray-900">{{item?.provider_transaction?.cash_register}}</p>
                </div>

                <!-- Cashier ID -->
                <div class="space-y-1 md:col-span-2 lg:col-span-3">
                  <p class="text-sm font-medium text-gray-500">C.I. Cajero</p>
                  <p class="text-sm text-gray-900">{{item?.provider_transaction?.user}}</p>
                </div>

                <!-- Plan -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Plan</p>
                  <p class="text-sm text-gray-900">{{item?.plan?.name}}</p>
                </div>

                <!-- Status -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Estatus</p>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="{
                          'bg-green-100 text-green-800': item?.payment_status?.code == 'PaymentComplete',
                          'bg-yellow-100 text-yellow-800': item?.payment_status?.code == 'PaymentPending',
                          'bg-gray-100 text-gray-800': item?.payment_status?.code == 'PaymentTrash'
                        }">
                    {{getStatusDisplayName(item?.payment_status?.name)}}
                  </span>
                </div>

                <!-- Installments -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Cuotas</p>
                  <div class="flex items-center justify-between">
                    <span class="text-sm text-gray-900">{{item?.plan?.number_installment}}</span>
                    <button (click)="getPersonInstallmentsInvoiceCredits(item)" class="text-sm text-blue-600 hover:text-blue-800 font-medium">
                      Ver cuotas
                    </button>
                  </div>
                </div>

                <!-- Initial Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto inicial</p>
                  <p class="text-sm text-gray-900">
                    {{item?.minimumPaymentDue | currency:'USD':'': '1.2-2'}}
                    <span class="text-xs text-gray-500">USD</span>
                  </p>
                </div>

                <!-- Financed Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto financiado</p>
                  <p class="text-sm text-gray-900">
                    {{item?.amount | currency:'USD':'': '1.2-2'}}
                    <span class="text-xs text-gray-500">USD</span>
                  </p>
                </div>

                <!-- Pending Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto pendiente</p>
                  <p class="text-sm text-gray-900">
                    {{item?.dueBalance | currency:'USD':'': '1.2-2'}}
                    <span class="text-xs text-gray-500">USD</span>
                  </p>
                </div>
              </div>

              <!-- Productos de la compra -->
              <div class="mt-4 pt-4 border-t border-gray-100" *ngIf="item?.order_items?.items?.length > 0 && (!_auth.hasRbac$.getValue() || _auth.hasPermission('compras_financiadas.productos.read'))">
                <p class="text-sm font-semibold text-gray-700 mb-2">
                  <i class="fas fa-box mr-1 text-blue-600"></i>
                  Productos ({{item.order_items.items.length}})
                </p>
                <div class="space-y-2">
                  <div *ngFor="let product of item.order_items.items"
                       class="flex items-center justify-between text-sm bg-gray-50 rounded px-3 py-2">
                    <div class="flex-1">
                      <span class="font-medium text-gray-800">{{product.name}}</span>
                      <span class="text-gray-500 ml-2">x{{product.quantity}}</span>
                    </div>
                    <span class="text-gray-700 font-mono">
                      {{product.unit_price | currency:'USD':'': '1.2-2'}} USD
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Load More Button -->
        <div *ngIf="!loading && rows?.length > 1" class="text-center mt-6">
          <button (click)="nextRows()" class="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            Siguientes +
          </button>
        </div>

        <!-- No Results -->
        <div *ngIf="!loading && rows?.length < 1" class="text-center py-12">
          <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <i class="fas fa-search text-2xl text-gray-400"></i>
          </div>
          <h3 class="text-lg font-medium text-gray-900 mb-2">No se encontraron registros</h3>
          <p class="text-gray-500">Intenta ajustar los filtros de búsqueda</p>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="flex items-center justify-center py-12">
          <div class="text-center">
            <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
            <p class="text-gray-600 mt-4">Cargando...</p>
          </div>
        </div>
      </div>

      <!-- View 2: Installments Detail -->
      <div *ngIf="view == 2" class="max-w-4xl mx-auto">

        <!-- Invoice Header -->
        <div *ngIf="installments" class="bg-white rounded-lg shadow-sm p-6 mb-6 text-center">
          <div class="border-b border-gray-200 pb-4 mb-4">
            <h2 class="text-xl font-bold text-gray-900 mb-2">Detalle de Cuotas</h2>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
            <div>
              <p class="text-sm font-medium text-gray-500">ID Transacción</p>
              <p class="text-lg font-semibold text-blue-600">{{invoiceSelected?.identifier}}</p>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Total</p>
              <p class="text-lg font-semibold text-gray-900">
                {{invoiceSelected?.totalAmount | currency:'USD':'': '1.2-2'}}
                <span class="text-sm font-normal text-gray-500">USD</span>
              </p>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Monto pendiente</p>
              <p class="text-lg font-semibold text-gray-900">
                {{invoiceSelected?.dueBalance | currency:'USD':'': '1.2-2'}}
                <span class="text-sm font-normal text-gray-500">USD</span>
              </p>
            </div>
          </div>

          <div class="mt-4">
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
              Cuotas: {{installments?.length}}
            </span>
          </div>
        </div>

        <!-- Installments List -->
        <div class="space-y-4">
          <div *ngFor="let item of installments; let i = index" class="bg-white rounded-lg shadow-sm">

            <!-- Installment Header -->
            <div class="p-4 border-b border-gray-200">
              <h3 class="text-lg font-semibold text-gray-900">
                {{ item?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + item?.installMent?.order}}
              </h3>
            </div>

            <!-- Installment Details -->
            <div class="p-6">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <!-- Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Total</p>
                  <p class="text-lg font-semibold text-gray-900">
                    {{item?.installMent?.amount | currency:'USD':'': '1.2-2'}} USD
                  </p>
                </div>

                <!-- Status -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Estatus</p>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="{
                          'bg-green-100 text-green-800': item?.installMent?.payment_status?.code == 'PaymentComplete',
                          'bg-yellow-100 text-yellow-800': item?.installMent?.payment_status?.code != 'PaymentComplete'
                        }">
                    {{item?.installMent?.payment_status?.name}}
                  </span>
                </div>

                <!-- Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha</p>
                  <p class="text-sm text-gray-900">{{item?.installMent?.date | date: 'dd/MM/yyyy'}}</p>
                </div>

                <!-- Payment Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha de Pago</p>
                  <p class="text-sm text-gray-900">{{item?.installMent?.scheduledPaymentDate | date: 'dd/MM/yyyy'}}</p>
                </div>

                <!-- Paid Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Pagada</p>
                  <p class="text-sm text-gray-900">
                    {{ (item?.installMent?.amount - item?.installMent?.dueBalance) | currency:'USD':'': '1.2-2'}} USD
                  </p>
                </div>

                <!-- Pending Reconciliation -->
                <div *ngIf="item?.totalpaymentReference > 0" class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Total (Por conciliar)</p>
                  <p class="text-sm text-gray-900">
                    {{item?.totalpaymentReference | currency:'USD':'': '1.2-2'}} USD
                  </p>
                </div>
              </div>

              <!-- External Payment Alert -->
              <div *ngIf="item?.installMent?.params?.external_payment_label" class="mt-4 p-4 bg-orange-50 border-l-4 border-orange-400 rounded-r">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-orange-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3 flex-1">
                    <p class="text-sm font-medium text-orange-800">
                      {{item?.installMent?.params?.external_payment_label}}
                    </p>
                    <p class="mt-1 text-xs text-orange-700">
                      Detectado: {{formatExternalPaymentDate(item?.installMent?.params?.external_payment_detected_at)}}
                    </p>
                  </div>
                </div>
              </div>

              <!-- View Payments Button -->
              <div *ngIf="item?.installMent?.payment_status?.code == 'PaymentComplete'" class="mt-4 text-right">
                <button (click)="getPersonInstallmentpayment(item?.installMent)" class="text-sm text-blue-600 hover:text-blue-800 font-medium">
                  Ver pagos
                </button>
              </div>

              <!-- Payments List -->
              <div *ngIf="item?.payments?.length > 0 || item?.paymentReference?.length > 0" class="mt-6 border-t border-gray-200 pt-6">
                <h4 class="text-sm font-semibold text-gray-900 mb-4">Pagos</h4>

                <div class="space-y-3">
                  <!-- Confirmed Payments -->
                  <div *ngFor="let item2 of item?.payments" class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div class="flex-1">
                      <p class="text-sm font-medium text-gray-900">{{item2?.payment?.paymentMethodId}}</p>
                      <button (click)="openBottom(paymentcontainer,{ person_code: item?.installMent?.invoice?.customer?.code, code_payment: item2?.payment?.code})"
                              class="text-xs text-blue-600 hover:text-blue-800">
                        {{item2?.payment?.code}}
                      </button>
                    </div>
                    <div class="text-right">
                      <p class="text-sm font-semibold text-gray-900">
                        {{item2?.amount | currency:'USD':'': '1.2-2'}} USD
                      </p>
                      <span *ngIf="item2?.payment?.reconciled_payment" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        Aprobado
                      </span>
                      <span *ngIf="!item2?.payment?.reconciled_payment" (click)="redirectTo(item?.customer?.code)" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 cursor-pointer">
                        Por conciliar
                      </span>
                    </div>
                  </div>

                  <!-- Payment References -->
                  <div *ngFor="let item2 of item?.paymentReference" class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div class="flex-1">
                      <p class="text-sm font-medium text-gray-900">{{item2?.payment?.paymentMethodId}}</p>
                      <p class="text-xs text-gray-500">{{item2?.payment?.code}}</p>
                    </div>
                    <div class="text-right">
                      <p class="text-sm font-semibold text-gray-900">
                        {{item2?.payment?.amount | currency:'USD':'': '1.2-2'}} USD
                      </p>
                      <span *ngIf="item2?.payment?.reconciled_payment" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        Conciliado
                      </span>
                      <span *ngIf="!item2?.payment?.reconciled_payment" (click)="redirectTo(item?.customer?.code)" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 cursor-pointer">
                        Por conciliar
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Missing Amount Alert -->
              <div *ngIf="((item?.installMent?.dueBalance - item?.totalpaymentReference) > 0) && invoiceSelected?.payment_status?.code != 'PaymentTrash'"
                   class="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                <div class="flex items-center">
                  <i class="fas fa-exclamation-triangle text-yellow-600 mr-2"></i>
                  <span class="text-sm font-medium text-yellow-800">
                    {{ (item?.installMent?.dueBalance - item?.totalpaymentReference) | currency:'USD':'': '1.2-2'}} USD faltantes
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- View 3: Payment Details -->
      <div *ngIf="view == 3" class="max-w-4xl mx-auto">

        <!-- Payment Header -->
        <div *ngIf="installments" class="bg-white rounded-lg shadow-sm p-6 mb-6 text-center">
          <div class="border-b border-gray-200 pb-4 mb-4">
            <h2 class="text-xl font-bold text-gray-900 mb-2">Detalle de Pago</h2>
          </div>

          <div class="text-center">
            <p class="text-sm font-medium text-gray-500">ID Transacción</p>
            <p class="text-lg font-semibold text-blue-600 mb-4">{{invoiceSelected?.identifier}}</p>

            <h3 class="text-lg font-bold text-gray-900">
              Pago {{ installMentSelected?.order < 1 ? 'Inicial' : 'Cuota ' + installMentSelected?.order }}
            </h3>
          </div>
        </div>

        <!-- Payment Details -->
        <div class="space-y-6">
          <div *ngFor="let payment of payment_base" class="bg-white rounded-lg shadow-sm">

            <!-- Payment Header -->
            <div class="p-4 border-b border-gray-200">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-semibold text-gray-900">Pago</h3>
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="{
                        'bg-green-100 text-green-800': payment?.payment?.typeTransaction == 'AUTO',
                        'bg-gray-100 text-gray-800': payment?.payment?.typeTransaction != 'AUTO'
                      }">
                  {{payment?.payment?.typeTransaction == 'AUTO' ? 'Auto' : 'Manual'}}
                </span>
              </div>
            </div>

            <!-- Payment Info -->
            <div class="p-6">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <!-- Code -->
                <div class="space-y-1 md:col-span-2 lg:col-span-3">
                  <p class="text-sm font-medium text-gray-500">Código</p>
                  <p class="text-sm text-gray-900 font-mono">{{payment?.payment?.code}}</p>
                </div>

                <!-- Conciliation -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Conciliación</p>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="{
                          'bg-green-100 text-green-800': payment?.payment?.typeTransaction == 'AUTO',
                          'bg-gray-100 text-gray-800': payment?.payment?.typeTransaction != 'AUTO'
                        }">
                    {{payment?.payment?.typeTransaction == 'AUTO' ? 'Auto' : 'Manual'}}
                  </span>
                </div>

                <!-- Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto total</p>
                  <p class="text-lg font-semibold text-gray-900">
                    {{payment?.payment?.amount | currency:'USD':'': '1.2-2'}} USD
                  </p>
                </div>

                <!-- Status -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Estatus</p>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Pago conciliado
                  </span>
                </div>

                <!-- Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha</p>
                  <p class="text-sm text-gray-900">{{payment?.payment?.date | date: 'dd/MM/yyyy h:mm:ss a'}}</p>
                </div>

                <!-- Payment Method -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Forma de Pago</p>
                  <p class="text-sm text-gray-900" [title]="payment?.payment?.payment_method?.description">
                    {{payment?.payment?.payment_method?.name}}
                  </p>
                </div>

                <!-- Confirmation Number -->
                <div class="space-y-1 md:col-span-2 lg:col-span-3">
                  <p class="text-sm font-medium text-gray-500">Número de confirmación</p>
                  <p class="text-sm text-gray-900 font-mono">{{payment?.payment?.paymentMethodId}}</p>
                </div>
              </div>

              <!-- Voucher Section -->
              <div *ngIf="payment?.payment?.responseAutoConfirm?.voucher" class="mt-6 border-t border-gray-200 pt-6">
                <h4 class="text-sm font-semibold text-gray-900 mb-4">Voucher</h4>

                <div *ngIf="payment?.payment?.responseAutoConfirm?.descripcion" class="mb-4">
                  <p class="text-sm font-medium text-gray-900">{{payment?.payment?.responseAutoConfirm?.descripcion}}</p>
                </div>

                <div class="bg-gray-50 rounded-lg p-4">
                  <div class="text-sm text-gray-900 font-mono whitespace-pre-wrap uppercase"
                       [innerHTML]="payment?.payment?.responseAutoConfirm?.voucher">
                  </div>
                </div>
              </div>

              <!-- Distribution Section -->
              <div *ngIf="payment?.installMentsPayment?.length > 0" class="mt-6 border-t border-gray-200 pt-6">
                <h4 class="text-sm font-semibold text-gray-900 mb-4">Distribución</h4>

                <div class="space-y-3">
                  <div *ngFor="let item of payment?.installMentsPayment" class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div>
                      <p class="text-sm font-medium text-blue-600">
                        {{ item?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + item?.installMent?.order }}
                      </p>
                      <p class="text-xs text-gray-500 font-mono">{{item?.installMent?.code}}</p>
                    </div>
                    <div>
                      <p class="text-sm font-semibold text-gray-900">
                        {{item?.amount | currency:'USD':'': '1.2-2'}} USD
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Payment Detail Modal -->
<ng-template #paymentcontainer let-offcanvas>
  <div class="flex items-center justify-between p-4 border-b border-gray-200">
    <h3 class="text-lg font-semibold text-gray-900">Detalle de Pago</h3>
    <button (click)="offcanvas.dismiss('Cross click')" class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="p-4">
    <app-person-payments
      [code_person]="params_payment['person_code']"
      [code_payment]="params_payment['code_payment']"
      (resetStatus)="response($event)">
    </app-person-payments>
  </div>
</ng-template>
